import pasteModalInDom from "./pasteModalInDom";

async function initAuthorizationModals() {
    if (!document.getElementById("modal-forget-password")) {
        await pasteModalInDom("modal-forget-password");
    }

    const authorizationBtn = document.querySelector(".authorization-toggle-btn");
    const authorizationLogin = document.querySelector("#authorization-login");
    const authorizationReg = document.querySelector("#authorization-reg");

    if (!authorizationBtn || !authorizationLogin || !authorizationReg) return;

    if (authorizationBtn.dataset.isRender === "1") return;
    authorizationBtn.dataset.isRender = "1";

    authorizationBtn.addEventListener("click", function (evt) {
        evt.preventDefault();

        if (authorizationBtn.innerHTML === "Регистрация на сайте") {
            authorizationBtn.innerHTML = "Войти в аккаунт";
        } else {
            authorizationBtn.innerHTML = "Регистрация на сайте";
        }

        authorizationLogin.classList.toggle("hide");
        authorizationReg.classList.toggle("hide");
    });
}

export default initAuthorizationModals;
